import React from "react";
import styles from "./Hero.module.css";

function Hero() {
    return (
        <section className={styles.hero}>

            {/* Trust Badge */}
            <div className={styles.badge}>
                <img src="./images/Frame2.svg" alt="badge" />
                <p>Trusted by Thousands of Customers</p>
            </div>

            {/* Headline Row */}
            <div className={styles.headlineRow}>
                <div className={styles.floatLeft}>
                    <img src="/images/Left-ellipse.png" alt="concierge" />
                </div>

                <div className={styles.headlineText}>
                    <h1>Your Personal Concierge. Digitally Delivered.</h1>
                    <p>Request errands, travel assistance, reservations, and lifestyle services from trusted professionals, all managed seamlessly through one simple digital concierge platform.</p>
                </div>

                <div className={styles.floatRight}>
                    <img src="/images/Right-ellipse.png" alt="concierge" />
                </div>
            </div>

            {/* Bottom Portrait Cards */}
            <div className={styles.portraitRow}>
                <div className={styles.portraitCard}>
                    <img src="/images/cashier.png" alt="concierge" loading="eager"/>
                </div>
                <div className={styles.portraitCard}>
                    <img src="/images/woman.png" alt="concierge" loading="eager" />
                </div>
                <div className={styles.portraitCard}>
                    <img src="/images/waiter.png" alt="concierge" loading="eager"/>

                </div>
            </div>
        </section>
    );
}

export default Hero;